import { useState, useEffect, useCallback } from 'react';
import { usersService } from '../services/usersService';

export function useUsersData() {
  const [usernames, setUsernames] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUsers = useCallback(async (forceRefresh = false) => {
    setLoading(true);
    setError(null);
    
    try {
      const data = await usersService.fetchUsernames(forceRefresh);
      setUsernames(data);
      return data;
    } catch (err) {
      // Silently handle errors
      setError(null);
      return {};
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch users on mount
  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  // Helper to get user fullname
  const getUserFullname = useCallback((userId) => {
    if (!userId) return '';
    return usernames[userId] || '';
  }, [usernames]);

  return {
    usernames,
    loading,
    error,
    fetchUsers,
    getUserFullname
  };
}